"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseForm = exports.InputForm = exports.Form = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_hook_form_1 = require("react-hook-form");
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = require("react");
var RHFInput_1 = require("@components/base/RHFInput");
var Button_1 = require("@components/base/Button");
var index_1 = require("@domain/login/index");
var usePasswordReset_1 = require("@store/login/usePasswordReset");
var useBreakpoints_1 = require("@hooks/useBreakpoints");
var PageTitle_1 = require("../PageTitle");
var Alert_1 = require("../Alert");
var LoginBackButton_1 = require("./LoginBackButton");
var ReissueButton = (0, styled_1.default)(Button_1.ButtonLarge)(function () { return ({
    fontWeight: 500,
    fontSize: "16px",
    width: "100%",
    maxWidth: "400px",
    "&.Mui-disabled": {
        backgroundColor: "#C0D3DF",
    },
}); });
var StylesRHFMailField = (0, styled_1.default)(RHFInput_1.RHFMailField)(function () { return ({
    "&:hover": {
        borderWidth: "2px",
    },
}); });
var styleOfWithoutLabelField = {
    marginTop: "24px",
    marginBottom: "48px",
    "& fieldset": {
        top: 0,
    },
    "& legend": {
        display: "none",
    },
};
var Form = function (_a) {
    var status = _a.status;
    var isUnderXs = (0, useBreakpoints_1.useIsUnderXs)();
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, { sx: { maxWidth: "400px", margin: "0 auto" }, children: [(0, jsx_runtime_1.jsx)(PageTitle_1.PageTitle, { title: "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A" }), (0, jsx_runtime_1.jsxs)(Box_1.default, { sx: isUnderXs ? index_1.styleForSp : {}, children: [(status === index_1.SEND_MAIL_BEFORE ||
                        status === index_1.SEND_MAIL_ERROR ||
                        status === index_1.SEND_MAIL_EXPIRED) && (0, jsx_runtime_1.jsx)(exports.InputForm, { status: status }), status === index_1.SEND_MAIL_SUCCESS && (0, jsx_runtime_1.jsx)(exports.CloseForm, {})] })] }));
};
exports.Form = Form;
var InputForm = function (_a) {
    var status = _a.status;
    var _b = (0, usePasswordReset_1.usePasswordReset)(), isDisabled = _b.isDisabled, csrfToken = _b.csrfToken;
    var _c = (0, react_1.useState)(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var DEFAULT_URL = "/password/reset";
    var _d = (0, react_hook_form_1.useForm)({
        mode: "onChange",
        defaultValues: {
            email: "",
        },
    }), control = _d.control, handleSubmit = _d.handleSubmit, _e = _d.formState, errors = _e.errors, isValid = _e.isValid;
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var form;
        return __generator(this, function (_a) {
            setIsSubmitting(true);
            form = document.getElementById("passwordResetForm");
            if (form) {
                form.submit();
            }
            return [2 /*return*/];
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (status !== index_1.SEND_MAIL_EXPIRED)
            return;
        var current_url = window.location.href;
        var url_index = current_url.indexOf(DEFAULT_URL);
        var updated_url = current_url.substring(0, url_index + DEFAULT_URL.length);
        window.history.replaceState({}, document.title, updated_url);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 暫定対応
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [status === index_1.SEND_MAIL_BEFORE && ((0, jsx_runtime_1.jsx)(Alert_1.AlertInfo, { message: "\u3054\u767B\u9332\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306EURL\u3092\u30E1\u30FC\u30EB\u3067\u304A\u9001\u308A\u3057\u307E\u3059\u3002" })), status === index_1.SEND_MAIL_ERROR && ((0, jsx_runtime_1.jsx)(Alert_1.AlertError, { message: "\u3053\u306E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u306F\u767B\u9332\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002" })), status === index_1.SEND_MAIL_EXPIRED && ((0, jsx_runtime_1.jsx)(Alert_1.AlertError, { message: "\u6709\u52B9\u671F\u9650\u304C\u5207\u308C\u3066\u3044\u308B\u305F\u3081\u3001\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u3092\u3084\u308A\u76F4\u3057\u3066\u304F\u3060\u3055\u3044\u3002" })), (0, jsx_runtime_1.jsxs)("form", { id: "passwordResetForm", onSubmit: handleSubmit(onSubmit), action: "/password/email", method: "post", children: [(0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "_token", value: csrfToken }), (0, jsx_runtime_1.jsx)(Box_1.default, { sx: styleOfWithoutLabelField, children: (0, jsx_runtime_1.jsx)(StylesRHFMailField, { name: "email", placeholder: "メールアドレスを入力してください", validationRules: index_1.validationRules.email, control: control }) }), (0, jsx_runtime_1.jsx)(Box_1.default, { children: (0, jsx_runtime_1.jsx)(ReissueButton, { "data-testid": "submitButton", disabled: isDisabled(isValid, isSubmitting, errors), type: "submit", children: "\u518D\u8A2D\u5B9A" }) })] })] }));
};
exports.InputForm = InputForm;
var CloseForm = function () {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, { sx: { mb: 3 }, children: (0, jsx_runtime_1.jsx)(Alert_1.AlertSuccess, { message: "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A\u30DA\u30FC\u30B8\u306EURL\u3092\u9001\u4FE1\u3057\u307E\u3057\u305F\u3002" }) }), (0, jsx_runtime_1.jsx)(Box_1.default, { sx: { mt: 12 }, children: (0, jsx_runtime_1.jsx)(LoginBackButton_1.LoginBackButton, {}) })] }));
};
exports.CloseForm = CloseForm;
